module.exports = __webpack_public_path__ + "img/setting.8528253c.svg";